import React, { createContext, useContext, useState } from 'react';

const CompanyContext = createContext();

const EMPTY = {
  name: '',
  tagline: '',
  email: '',
  phone: '',
  website: '',
  gstin: '',
  address: '',
  city: '',
  state: '',
  pincode: '',
  country: 'India',
  contactName: '',
  users: '',
  logo: '',
  services: [],
  bank: { accName: '', accNumber: '', bank: '', branch: '', ifsc: '' },
};

function loadInitial() {
  try {
    const profile = JSON.parse(localStorage.getItem('ryzenos_company_profile') || 'null');
    const onboarding = JSON.parse(localStorage.getItem('ryzenos_company') || 'null');
    const src = profile || onboarding;
    if (!src) return EMPTY;
    return { ...EMPTY, ...src, bank: { ...EMPTY.bank, ...(src.bank || {}) }, services: Array.isArray(src.services) ? src.services : [] };
  } catch { return EMPTY; }
}

export function CompanyProvider({ children }) {
  const [company, setCompany] = useState(loadInitial);
  const isComplete = !!(company.name && company.email && company.phone && company.address);
  const update = (data) => setCompany(prev => ({ ...prev, ...data }));
  return (
    <CompanyContext.Provider value={{ company, update, isComplete }}>
      {children}
    </CompanyContext.Provider>
  );
}

export const useCompany = () => useContext(CompanyContext);
